import { Config } from '@catalogo/core-configuration';
import { PageLoadEvent, NPLEvent } from '../../../types/events';
import defaultPayload from './default-payload';
import searchPayload from './search-payload';
import productPayload from './product-payload';
import newsletterPayload from './newsletter-payload';
import nplPayload from './npl-payload';
import { PageViewEvent } from '../../../types/datalayer/pageview';
import { PageViewNPL } from '../../../types/datalayer/pageview-npl';
import { eventData } from '../../../types/datalayer/datalayer';

const getCustomPayload = (type: string, pageload: PageLoadEvent, config: Config) => {
  switch (type) {
    case 'search':
      return searchPayload(pageload);
    case 'product':
      return productPayload(pageload, config);
    case 'newsletter':
      return newsletterPayload(pageload);
    default:
      return {};
  }
};

export const pageView = (events: eventData, config: Config): void => {
  const pageload = events['page:load'][0] as PageLoadEvent;
  const { type } = pageload.detail?.page;

  if (['store-list', 'store-offers', 'open-store-search'].includes(type)) {
    return;
  }

  const defaultEvent = defaultPayload(pageload, config);
  const customPayload = getCustomPayload(type, pageload, config);
  const event = { ...defaultEvent, ...customPayload } as PageViewEvent;

  window.dataLayer = window.dataLayer || [{}];
  window.dataLayer.push(event);
};

export const pageViewNPL = (events: eventData, config: Config): void => {
  const pageload = events['page:load'][0] as PageLoadEvent;
  const nplLoad = events['npl:load'][0] as NPLEvent;

  const defaultEvent = defaultPayload(pageload, config);
  const nplEvent = nplPayload(nplLoad);

  const event = { ...defaultEvent, ...nplEvent } as PageViewNPL;

  window.dataLayer = window.dataLayer || [{}];

  if (window.dataLayer.find(e => e.event?.includes('pageview'))) {
    event['gtm.start'] = +new Date();
  }

  window.dataLayer.push(event);
};
